export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.querySelector("script[data-razorpay-checkout]");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Razorpay failed to load")));
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.dataset.razorpayCheckout = "true";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Razorpay failed to load"));
    document.body.appendChild(script);
  });
}

export function openRazorpayCheckout({
  key,
  orderId,
  amount,
  currency = "INR",
  name = "FastSearch",
  description,
  prefill = {},
}) {
  return new Promise((resolve, reject) => {
    if (!window.Razorpay) {
      reject(new Error("Razorpay checkout is not available."));
      return;
    }
    if (!key || !orderId) {
      reject(new Error("Payment session is incomplete. Try again."));
      return;
    }
    const isTestKey = String(key).startsWith("rzp_test_");
    // Test-mode QR is not a real UPI collect. PhonePe/GPay show "Invalid QR".
    // Razorpay only allows scanning live-mode QRs. Hide QR in test checkout.
    const checkout = new window.Razorpay({
      key,
      amount,
      currency,
      name,
      description: description || "Subscription payment",
      order_id: orderId,
      prefill,
      ...(isTestKey
        ? {
            config: {
              display: {
                hide: [{ method: "upi", flows: ["qr"] }],
              },
            },
          }
        : {}),
      handler(response) {
        resolve(response);
      },
      modal: {
        ondismiss() {
          reject(new Error("CHECKOUT_CLOSED"));
        },
      },
    });
    checkout.on("payment.failed", () => {
      reject(new Error("PAYMENT_FAILED"));
    });
    checkout.open();
  });
}
